var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner-base"},[(_vm.UrlList)?_c('img',{attrs:{"src":'http://'+_vm.UrlList}}):_vm._e(),_c('div',{staticClass:"partner-content"},[_c('image-show',{attrs:{"image-list":_vm.result}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }